import { webApiService } from '@/services'
import { Button } from '@/components/ui/button'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { MdOutlineArrowOutward } from 'react-icons/md'
import { useParams } from 'react-router-dom'
import { useTradeinContext } from '../hooks/useTradeinContext'

const ForwardGiftcard = () => {
  const [data, setData] = useState<{ loading: boolean }>({ loading: false })
  const { slug } = useParams()
  const { ctx } = useTradeinContext()

  const handleForward = () => {
    setData({ ...data, loading: true })
    webApiService.sendGiftcard({ seller: String(slug), id: ctx.tradein.id }).then(() => {
      setData({ ...data, loading: false })
      enqueueSnackbar('Giftcard enviada correctamente', { variant: 'success' })
    }).catch((error) => {
      enqueueSnackbar(error.response.data.message, { variant: 'error' })
      setData({ ...data, loading: false })
      console.log('error ==>', error.response.data.message)
    })
  }

  return (
    <Button
      size='sm'
      legacyColor='success'
      legacyVariant='shadow'
      disabled={data.loading}
      onClick={() => { handleForward() }}
    >
      <MdOutlineArrowOutward />
      {data.loading ? 'Enviando...' : 'Reenviar Giftcard'}
    </Button>
  )
}

export default ForwardGiftcard
